import { render, staticRenderFns } from "./ProductsCreation.vue?vue&type=template&id=437612d8&scoped=true"
import script from "./ProductsCreation.vue?vue&type=script&lang=js"
export * from "./ProductsCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437612d8",
  null
  
)

export default component.exports